module.exports = __webpack_public_path__ + "static/media/icon-camera.22409d72.png";